import axios from '@axios'

const PREFIX = '/plataforma/email-configuracao'

export default {

  getEmailConfiguracao() {
    return axios.get(`${PREFIX}`)
  },

  updateEmailConfiguracao(config) {
    return axios.post(`${PREFIX}`, config)
  },

  autenticarGoogle(codeResponse, emailSMTP) {
    return axios.get(`${PREFIX}/login-google?code=${codeResponse}&email=${emailSMTP}`)
  },

  deslogarGoogle() {
    return axios.get(`${PREFIX}/out-google`)
  },

  configuradoGoogle() {
    return axios.get(`${PREFIX}/configurado-google`)
  },

  getClientGoogle() {
    return axios.get(`${PREFIX}/client`)
  },
}
